import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
`;

export const ContainerImages = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
	gap: 1rem;
`;

export const Image = styled.img`
	cursor: pointer;
	width: 100px;
	height: 100px;
	object-fit: contain;
	border: 1px solid ${({ theme }) => theme.grayLight};
	box-shadow: 0px 0px 10px 0px rgb(0 0 0 / 12%);
`;
